module.exports = __webpack_public_path__ + "img/21-about.b5296d17.jpg";